import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLike, pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ConstOperatorParameters} from "#template/nodes/geometry-graph/attribute/const-operator/geometry-const-operator-node"
import {GeometryConstOperatorNode, constOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/const-operator/geometry-const-operator-node"

export type PointGeometryConstOperatorParameters = ConstOperatorParameters<PointGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<PointGeometryConstOperatorParameters> = {
    nodeClass: "PointGeometryConstOperator",
    validation: {
        parameters: constOperatorParametersSchema(pointGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryConstOperator extends GeometryConstOperatorNode<0, PointGeometryAttributeLikeNode> implements PointGeometryAttributeLikeNode {
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
